import { reactFilter, TextLike } from 'mk/bazaar/common/filters/utils';
import { Link } from 'mk2/components/Link';
import React from 'react';

// const HASHIZE_RE = /(?:\s|^)#([a-zA-Z0-9.][a-zA-Z0-9._]+)/;
const HASHIZE_RE = /(?:\s|^)[#＃]([a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF._]+)/gu;

export const hashize = (text: TextLike, urlFn: (hash: string) => string) => reactFilter(text, (s: string): React.ReactChild[] => {
    const ret: React.ReactChild[] = [];
    const matcher = new RegExp(HASHIZE_RE); // Reinit each loop

    let from = 0;
    let match: RegExpExecArray | null = matcher.exec(s);

    while (match !== null) {
      const rawHash = match[1];
      const normalizedHash = rawHash.toLowerCase();

      const matchStart = match.index!;

      // Copy text before this match
      ret.push(s.substring(from, matchStart));

      // Add the link
      ret.push(<Link to={urlFn(normalizedHash)}>#{normalizedHash}</Link>);

      from = matcher.lastIndex;
      match = matcher.exec(s); // advance matcher
    }

    // Copy the remainder of the string
    ret.push(s.substring(from));
    return ret;
  });
